export const TRANSLATION_PATH = (route) => {
  return `components.ui.pointsSummary.${route}`;
};
